/**
 * Catégories Shape (sections/shape-categories.liquid).
 * - Flèches : défilement d'environ une largeur visible, désactivées aux extrémités
 * - Barre de progression : taille = part visible du rail, position = avancement du défilement
 * - Apparition en cascade quand la section entre dans l'écran
 */
class ShapeCategories extends HTMLElement {
  connectedCallback() {
    this.rail = /** @type {HTMLElement | null} */ (this.querySelector('[data-rail]'));
    this.progress = /** @type {HTMLElement | null} */ (this.querySelector('[data-progress]'));
    this.arrows = /** @type {HTMLButtonElement[]} */ ([...this.querySelectorAll('[data-direction]')]);
    if (!this.rail) return;

    this.arrows.forEach((arrow) =>
      arrow.addEventListener('click', () => {
        const direction = Number(arrow.dataset.direction);
        this.rail?.scrollBy({ left: direction * this.rail.clientWidth * 0.8 });
      })
    );

    this.rail.addEventListener('scroll', this.#update, { passive: true });
    new ResizeObserver(this.#update).observe(this.rail);
    this.#update();

    // Apparition en cascade
    this.classList.add('is-ready');
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.classList.add('is-visible');
        observer.disconnect();
      },
      { threshold: 0.2 }
    );
    observer.observe(this);
  }

  #update = () => {
    const rail = this.rail;
    if (!rail) return;
    const max = rail.scrollWidth - rail.clientWidth;
    const ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
    const progress = max > 0 ? rail.scrollLeft / max : 0;

    if (this.progress) {
      const track = this.progress.parentElement?.clientWidth ?? 0;
      const thumb = Math.max(ratio, 0.08) * track;
      this.progress.style.setProperty('--cat-thumb', `${thumb}px`);
      this.progress.style.setProperty('--cat-offset', `${progress * (track - thumb)}px`);
    }

    const [previous, next] = this.arrows;
    if (previous) previous.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
  };
}

if (!customElements.get('shape-categories')) {
  customElements.define('shape-categories', ShapeCategories);
}
